// ============================================================================
// CONGOLESE (LINGALA) TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Mituna ya esengo mpo na kotalela

export const funQuestionsRc = [
  {
    question: "Likambo nini ya bolingo ya Yesu epesaka yo molende mingi koleka na bomoi na yo ya mokolo na mokolo?",
    emoji: "❤️",
    theme: "Bolingo"
  },
  {
    question: "Eloko nini ya bokeli ya Nzambe emonisaka yo bonene na Ye mingi koleka?",
    emoji: "🌟",
    theme: "Bokeli"
  },
  {
    question: "Verset nini ya Biblia epesaki yo libondisi na ntango ya mpasi?",
    emoji: "🕊️",
    theme: "Libondisi"
  },
  {
    question: "Moto nani ya Biblia apesaka yo molende mingi koleka mpe mpo na nini?",
    emoji: "⭐",
    theme: "Molende"
  },
  {
    question: "Mapamboli nini osepelaka mingi mpo na yango na bomoi na yo?",
    emoji: "🙏",
    theme: "Botondi"
  },
  {
    question: "Lisese nini ya Yesu epusaki mobembo na yo ya molimo mingi koleka?",
    emoji: "📖",
    theme: "Boteyi"
  },
  {
    question: "Likambo nini ya bomoi ya Nzambe ezali na ntina mingi mpo na yo? (bolingo, bosembo, mawa...)",
    emoji: "✨",
    theme: "Bomoi"
  },
  {
    question: "Tango nini kondima na yo ekolaki na lolenge oyo ozalaki kozela te?",
    emoji: "💪",
    theme: "Kondima"
  }
];

export default funQuestionsRc;
